
import Vue from 'vue';
import api from '@/api/api';
import { store } from '@/store';
import { M_MENU } from '@/store/mutations-types';
import { columns } from '@/utils/columns';
import Grid from '@/components/Grid.vue';
import ModalCrud from '@/components/ModalCrud.vue';
import MultipleSelect from '@/components/MultipleSelect.vue';

export default Vue.extend({
	name: 'TiposControleFinanceiro',
	data() {
		return {
			grid: {
				isLoading: false,
				columns: columns.cadastros.tiposControleFinanceiro,
				dataset: []
			},
			gridItemsActions: [
				{
					label: 'Editar',
					action: 'edit',
					icon: 'mdi-pencil',
					color: 'primary',
					display: true,
					loading: false
				},
			],
			modals: {
				criarEditarTipo: {
					isLoading: false,
					visible: false,
					title: ''
				},
			},
			forms: {
				criarEditarTipo: {
					data: {
						id: 0,
						descricao: '',
						obrigaCidade: 0,
						idStatus: false,
					},
					controls: {
						isValid: true,
						rules: [
							v => !!v || 'Descrição precisa ser preenchida.',
						]
					}
				},
			},
		}
	},
	components: {
		Grid,
		ModalCrud,
		MultipleSelect,
	},
	methods: {
		loadDataGrid: async function () {
			try {
				this.grid.isLoading = true;

				const response = await api.get('/types-financial-control');
				this.grid.dataset = response.data;
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.grid.isLoading = false;
			}
		},
		showModalNewEditTipo: async function (item) {
			try {
				this.modals.criarEditarTipo.title = item.id ? `${item.id} - Editar Tipo` : 'Nova Tipo';
				this.modals.criarEditarTipo.visible = true;
				this.modals.criarEditarTipo.isLoading = true;

				if (item.id) {
					const { data } = await api.get(`/types-financial-control/${item.id}`);

					this.forms.criarEditarTipo.data = {
						id: data.id,
						descricao: data.descricao,
						obrigaCidade: data.obrigaCidade === 1,
						idStatus: data.idStatus === 'A'
					};
				};
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.modals.criarEditarTipo.isLoading = false;
			}
		},
		closeModalNewEditTipo: function () {
			this.modals.criarEditarTipo.visible = false;
			this.forms.criarEditarTipo.data = {
				id: 0,
				descricao: '',
				obrigaCidade: 0,
				idStatus: false,
			};
		},
		saveTipo: async function () {
			try {
				if (this.$refs.form.validate()) {
					this.modals.criarEditarTipo.isLoading = true;

					const [metodo, mensagem] = this.forms.criarEditarTipo.data.id ? ['put', 'alterada'] : ['post', 'criada'];
					await api[metodo]('/types-financial-control', this.forms.criarEditarTipo.data);

					this.$toast.success(`Tipo ${mensagem} com sucesso!`);
					this.closeModalNewEditTipo();
					this.loadDataGrid();
				} else {
					this.$toast.warning('Formulário inválido! Verifique os dados.');
				}
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.modals.criarEditarTipo.isLoading = false;
			}
		},
		handleGridItemsActions: function (action: 'edit', item) {
			switch (action) {
				case 'edit':
					this.showModalNewEditTipo(item);
					break;
				default:
					this.$toast.error('Opção de ação inválida!');
			};
		},
	},
	async mounted() {
		store.commit(M_MENU, "Tipos - Controle Financeiro");
		await this.loadDataGrid();
	},
})

